import script from "./domainNameUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./domainNameUpdate.vue?vue&type=script&setup=true&lang=js"

import "./domainNameUpdate.vue?vue&type=style&index=0&id=a5cf8608&lang=scss"

const __exports__ = script;

export default __exports__